function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
jQuery(document).ready(function() {
    console.log("ready sortandfilter js!");
    var storeIDs = [];
    var sortedStoreIDs = [];
    var outOfBoundsStoreIDs = [];
    var currentZipcode = "55123";
    // let currentSearchWithin = 1000;
    var cardList = jQuery(".vehicle-grid");
    var cards = jQuery(".vehicle-card");
    getStoreIDs();
    var zipEntered = false;
    var initializing = true;
    // Populate the storeIds array
    function getStoreIDs() {
        // console.log('--getStoreIDs');
        jQuery(".vehicle-card").each(function() {
            var card = jQuery(this);
            var store = card.data("store");
            storeIDs.push(store);
            storeIDs = _to_consumable_array(new Set(storeIDs));
        });
    // console.log('storeIDs');
    // console.log(storeIDs);
    }
    function addZipError(triggerLowtoHigh) {
        if (!jQuery("#zipcode").hasClass("input-error")) {
            jQuery("#zipcode").addClass("input-error");
        }
        if (!jQuery("#zipcode").siblings().hasClass("error-message")) {
            jQuery('<p class="error-message">Please enter your zip code.</p>').insertAfter("#zipcode");
        }
        if (triggerLowtoHigh) {
            jQuery('#sort-options > [data-value="lowtohigh"]').trigger("click");
            jQuery("#sort-options-label").trigger("click");
        }
    }
    jQuery(".custom-select #sort-options > div").click(function() {
        var selected = jQuery(this);
        var sortOrder = selected.data("value");
        // console.log('sortOrder: ' + sortOrder);
        switch(sortOrder){
            case "distance":
                console.log("sorting by distance");
                console.log(zipEntered);
                if (!zipEntered) {
                    // alert('ENTER ZIP');
                    addZipError(true);
                    break;
                }
                getStoreIDs();
                sortNearest();
                break;
            case "lowtohigh":
                console.log("sorting low to high");
                sortAsc();
                break;
            case "hightolow":
                console.log("sorting high to low");
                sortDesc();
                break;
            default:
                break;
        }
    });
    function sortAsc() {
        jQuery(".vehicle-grid, .no-options-container").hide();
        jQuery(".spinner").show();
        cards.detach().sort(function(a, b) {
            return jQuery(a).data("price") - jQuery(b).data("price");
        });
        cardList.append(cards);
        jQuery(".spinner").hide();
        showResults();
    }
    function sortDesc() {
        jQuery(".vehicle-grid, .no-options-container").hide();
        jQuery(".spinner").show();
        cards.detach().sort(function(a, b) {
            return jQuery(b).data("price") - jQuery(a).data("price");
        });
        cardList.append(cards);
        jQuery(".spinner").hide();
        showResults();
    }
    function sortNearest() {
        // console.log('---sortNearest');
        //show loader
        jQuery(".vehicle-grid, .no-options-container").hide();
        jQuery(".spinner").show();
        // console.log(currentZipcode);
        // console.log(storeIDs);
        //Get sorted store IDs on default zipcode on page load
        sortedStoreIDs = getSortedStoreIDs(currentZipcode, storeIDs).then(function(data) {
            // console.log('sortedStoreIDs');
            // console.log(sortedStoreIDs);
            // sort the vehicle card divs
            jQuery.each(sortedStoreIDs, function(index, item) {
                // console.log('item');
                // console.log(item);
                var matchingVehicleCards = jQuery('[data-store="' + item + '"]');
                // console.log('matchingVehicleCards');
                // console.log(matchingVehicleCards);
                jQuery.each(matchingVehicleCards, function(index, item) {
                    // console.log('--itemxx');
                    // console.log(item);
                    var detachedItem = jQuery(item).detach();
                    jQuery(".vehicle-grid").append(detachedItem);
                });
            });
            updateOutOfBoundsStoreIDs(sortedStoreIDs);
        }).then(function() {
            //hide the
            //show the grid
            hideOutOfBoundsCards();
            filterResults();
            // console.log('DONE SORTING By DIstance');
            jQuery(".spinner").hide();
            showResults();
        });
    }
    function updateOutOfBoundsStoreIDs($withinBoundsStoreIDs) {
        // console.log('---updateOutOfBoundsStoreIDs');
        getStoreIDs();
        outOfBoundsStoreIDs = [];
        // console.log('storeIDs: ' + storeIDs);
        // console.log('sortedStoreIDs: ' + sortedStoreIDs);
        jQuery.each(storeIDs, function(index, item) {
            if (jQuery.inArray(item, sortedStoreIDs) == -1) {
                outOfBoundsStoreIDs.push(item);
            }
        });
    // console.log('outOfBoundsStoreIDs: ' + outOfBoundsStoreIDs);
    }
    function getSortedStoreIDs($zipcode, $storeIDs) {
        return _getSortedStoreIDs.apply(this, arguments);
    }
    function _getSortedStoreIDs() {
        _getSortedStoreIDs = // sort by DISTANCE
        _async_to_generator(function($zipcode, $storeIDs) {
            var searchWithin, paramData;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // console.log('---getSortedStoreIDs');
                        searchWithin = jQuery("#radius-options .selected").data("value");
                        // console.log('searchWithin: ' + searchWithin);
                        paramData = {
                            action: "sort_dealers_by_zip",
                            zipCode: $zipcode,
                            sortOrder: "ASC",
                            searchDistance: searchWithin,
                            dealerPostIds: $storeIDs,
                            nonce: my_ajax_obj.ajax_nonce
                        };
                        return [
                            4,
                            jQuery.ajax({
                                url: my_ajax_obj.ajax_url,
                                _ajax_nonce: my_ajax_obj.ajax_nonce,
                                data: paramData,
                                type: "POST",
                                error: function error() {},
                                success: function success(data) {
                                    var jsonData = JSON.parse(data);
                                    console.log("ZIP RESULTs");
                                    console.log(jsonData);
                                    sortedStoreIDs = jsonData.result;
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _getSortedStoreIDs.apply(this, arguments);
    }
    jQuery(".custom-select #radius-options > div").click(function() {
        // console.log(zipEntered);
        // console.log(initializing);
        var selected = jQuery(this);
        var radiusBound = selected.data("value");
        jQuery(".result-copy-miles").text(radiusBound);
        if (!zipEntered && !initializing) {
            addZipError(false);
            return;
        } else if (initializing) {
            initializing = false;
            return;
        }
        jQuery(".vehicle-grid, .no-options-container").hide();
        jQuery(".spinner").show();
        if (radiusBound == "1000000") {
            radiusBound = "1000+";
        }
        // console.log('radiusBound: ' + radiusBound);
        //Get list of in bound store IDs
        sortedStoreIDs = getSortedStoreIDs(currentZipcode, storeIDs).then(function(data) {
            // console.log('sortedStoreIDs');
            // console.log(sortedStoreIDs);
            updateOutOfBoundsStoreIDs(sortedStoreIDs);
        }).then(function() {
            // console.log('now filter out the out of bounds cards');
            hideOutOfBoundsCards();
            filterResults();
            jQuery(".spinner").hide();
            showResults();
        });
    });
    function hideOutOfBoundsCards() {
        // console.log('---hideOutOfBoundsCards');
        jQuery(".vehicle-card").each(function() {
            var card = jQuery(this);
            var storeID = card.data("store");
            // console.log('storeID: ' + storeID);
            if (jQuery.inArray(storeID, outOfBoundsStoreIDs) !== -1) {
                card.addClass("out-of-bounds");
                card.addClass("hidden-card");
            } else {
                if (card.hasClass("out-of-bounds")) {
                    card.removeClass("out-of-bounds");
                    card.removeClass("hidden-card");
                }
            }
        });
    }
    setTimeout(function() {
        //Default page sorting set to lowtohigh
        jQuery(".custom-select #sort-options-label").trigger("click");
        jQuery('.custom-select #sort-options [data-value="lowtohigh"]').trigger("click");
    }, 100);
    setTimeout(function() {
        //Default radius filter to last option
        zipEntered = true;
        jQuery(".custom-select #radius-options-label").trigger("click");
        jQuery(".custom-select #radius-options div:last-child").trigger("click");
        zipEntered = false;
    }, 200);
    setTimeout(function() {
        jQuery(".aslider").slick({
            infinite: false,
            adaptiveHeight: true,
            regionLabel: "main image carousel",
            dots: false
        });
        jQuery(".aslider").slick("slickSetOption", "refresh");
    }, 1000);
    //when zipcode entered, click sort by distance
    jQuery("input#zipcode").on("keyup", function() {
        // console.log('keypress');
        var maxLength = jQuery(this).attr("maxlength");
        if (jQuery(this).val().length < maxLength) {
            addZipError(false);
        }
        if (maxLength == jQuery(this).val().length) {
            //   alert("You can't write more than " + maxLength + ' chacters');
            currentZipcode = jQuery(this).val();
            zipEntered = true;
            jQuery("#zipcode").removeClass("input-error");
            jQuery(".error-message").remove();
            jQuery(".result-copy-zipcode").text(currentZipcode);
            jQuery(".no-zip").hide();
            jQuery(".zip-entered").show();
            jQuery('#sort-options > [data-value="distance"]').trigger("click");
            jQuery("#sort-options-label").trigger("click");
        }
    });
    // ---------------------------- FILTERING STUFF ----------------------------
    var isColorFitered = false;
    var isDoorFitered = false;
    var isSeatFitered = false;
    var activeColorFilters = [];
    var activeDoorFilters = [];
    var activeSeatFilters = [];
    jQuery("input:checkbox").change(function() {
        var input = jQuery(this);
        // console.log(input);
        // action when checked
        if (jQuery(this).is(":checked")) {
            activateFilter(input);
        } else {
            deactivateFilter(input);
        }
        filterResults();
    });
    function activateFilter(input) {
        var inputValue = input.val();
        var inputSection = input.data("section");
        // console.log('inputValue: ' + inputValue);
        // console.log('inputSection: ' + inputSection);
        switch(inputSection){
            case "color":
                activeColorFilters.push(inputValue);
                isColorFitered = true;
                break;
            case "door":
                activeDoorFilters.push(inputValue);
                isDoorFitered = true;
                break;
            case "seat":
                activeSeatFilters.push(inputValue);
                isSeatFitered = true;
                break;
            default:
                break;
        }
    // console.log(activeColorFilters);
    // console.log(activeDoorFilters);
    // console.log(activeSeatFilters);
    // console.log('isColorFitered: ' + isColorFitered);
    // console.log('isDoorFitered: ' + isDoorFitered);
    // console.log('isSeatFitered: ' + isSeatFitered);
    }
    function deactivateFilter(input) {
        var inputValue = input.val();
        var inputSection = input.data("section");
        switch(inputSection){
            case "color":
                activeColorFilters = jQuery.grep(activeColorFilters, function(value) {
                    return value != inputValue;
                });
                if (!activeColorFilters.length) {
                    isColorFitered = false;
                }
                break;
            case "door":
                activeDoorFilters = jQuery.grep(activeDoorFilters, function(value) {
                    return value != inputValue;
                });
                if (!activeDoorFilters.length) {
                    isDoorFitered = false;
                }
                break;
            case "seat":
                activeSeatFilters = jQuery.grep(activeSeatFilters, function(value) {
                    return value != inputValue;
                });
                if (!activeSeatFilters.length) {
                    isSeatFitered = false;
                }
                break;
            default:
                break;
        }
    // console.log(activeColorFilters);
    // console.log(activeDoorFilters);
    // console.log(activeSeatFilters);
    // console.log('isColorFitered: ' + isColorFitered);
    // console.log('isDoorFitered: ' + isDoorFitered);
    // console.log('isSeatFitered: ' + isSeatFitered);
    }
    function filterResults() {
        jQuery(".vehicle-card:not(.out-of-bounds)").each(function(index, element) {
            // console.log('CARD: ');
            // console.log(element);
            // console.log(jQuery(this));
            element = jQuery(this);
            var colorValue = element.data("color");
            var doorValue = element.data("doors");
            var seatValue = element.data("seats");
            var colorMatch, doorMatch, seatMatch = false;
            if (isColorFitered) {
                if (jQuery.inArray(colorValue, activeColorFilters) !== -1) {
                    colorMatch = true;
                }
            } else {
                colorMatch = true;
            }
            if (isDoorFitered) {
                if (jQuery.inArray(doorValue, activeDoorFilters) !== -1) {
                    doorMatch = true;
                }
            } else {
                doorMatch = true;
            }
            if (isSeatFitered) {
                if (jQuery.inArray(seatValue, activeSeatFilters) !== -1) {
                    seatMatch = true;
                }
            } else {
                seatMatch = true;
            }
            if (colorMatch && doorMatch && seatMatch) {
                //show this card
                if (element.hasClass("hidden-card")) {
                    element.removeClass("hidden-card");
                }
                element.show();
            } else {
                //hide this card
                if (!element.hasClass("hidden-card")) {
                    element.addClass("hidden-card");
                }
                element.hide();
            }
        });
        showResults();
    }
    function showResults() {
        if (jQuery(".hidden-card").length == jQuery(".vehicle-card").length) {
            jQuery(".no-options-container").show();
            jQuery(".vehicle-grid").hide();
        } else {
            jQuery(".no-options-container").hide();
            jQuery(".vehicle-grid").show();
        }
    }
    jQuery(".no-zip").click(function() {
        jQuery("#filter-container-label").trigger("click");
    });
    jQuery(".header-filter-container button").click(function() {
        var label = jQuery(this);
        var expanded = label.attr("aria-expanded");
        var contentID = label.attr("aria-controls");
        // console.log(expanded);
        if (expanded == "true") {
            label.attr("aria-expanded", "false");
            jQuery("#".concat(contentID)).hide();
        } else {
            label.attr("aria-expanded", "true");
            jQuery("#".concat(contentID)).show();
            // close the other ones
            jQuery(".header-filter-container button").each(function() {
                var element = jQuery(this);
                var elTitle = element.find(".label");
                var otherContentID = jQuery(element).attr("aria-controls");
                if (otherContentID !== contentID) {
                    element.attr("aria-expanded", "false");
                    jQuery("#".concat(otherContentID)).hide();
                }
            });
        }
    });
    jQuery("#filter-container-label-old").click(function() {
        // console.log('Toggling filter on mobile');
        var label = jQuery(this);
        var expanded = label.attr("aria-expanded");
        // console.log(label);
        // console.log(expanded);
        if (expanded == "true") {
            label.attr("aria-expanded", "false");
            jQuery("#filter-container").hide();
            label.text("Filters");
        } else {
            label.attr("aria-expanded", "true");
            jQuery("#filter-container").show();
            label.text("X");
        }
    });
});
